import React from 'react';
import { useNavigate } from 'react-router-dom';
import './Footer.css';

function Footer() {
  const navigate = useNavigate();
  const currentYear = new Date().getFullYear();

  return (
    <footer className="page-footer">
      <div className="footer-container">
        <div className="footer-left">
          <span className="footer-brand" onClick={() => navigate('/')}>
            <img src="/PMlogoleft.png" alt="Playmaker Media Kit" />
          </span>
          <span className="footer-copyright">
            © {currentYear} All rights reserved. USA
          </span>
        </div>

        <div className="footer-right">
          <p className="footer-question">Questions or feedback?</p>

          <a href="/contact" className="footer-email">
            Contact Us
          </a>

          <div className="footer-links">
            <a href="/about">About Us</a>
            <span> • </span>
            <a href="/privacy">Privacy Policy</a>
            <span> • </span>
            <a href="/cookie-policy">Cookie Policy</a>
            <span> • </span>
            <a href="/terms">Terms of Service</a>
            <span> • </span>
            {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
            <a href="#" className="termly-display-preferences">Consent Preferences</a>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
